<template>
  <div class="menu clear-fix">
    <div class="menu-item" @click="goStoreclass">
      <i class="iconfont"><img class="menu-item-icon" src="../../../assets/image/home/icon_shop_classify_pre.png" /></i>
      <span class="menu-item-title">店铺分类</span>
    </div>
    <div class="menu-item" @click="goBrand">
      <i class="iconfont"><img class="menu-item-icon" src="../../../assets/image/home/icon_brand_name_pre.png" /></i>
      <span class="menu-item-title">品牌</span>
    </div>
    <div class="menu-item" @click="goPintuan">
      <i class="iconfont"><img class="menu-item-icon" src="../../../assets/image/home/icon_top_round_pre.png" /></i>
      <span class="menu-item-title">拼团</span>
    </div>
    <div class="menu-item" @click="goBargain">
      <i class="iconfont"><img class="menu-item-icon" src="../../../assets/image/home/icon_top_bargain_pre.png" /></i>
      <span class="menu-item-title">砍价</span>
    </div>
    <div class="menu-item" @click="goMemberPointSignin">
      <i class="iconfont"><img class="menu-item-icon" src="../../../assets/image/home/icon_top_signin_pre.png" /></i>
      <span class="menu-item-title">签到</span>
    </div>
    <div class="menu-item">
      <i class="iconfont"><img class="menu-item-icon" @click="$router.push({name:'HomeGoodslist',query:{xianshi:1}})" src="../../../assets/image/home/icon_top_discount_pre.png" /></i>
      <span class="menu-item-title">秒杀</span>
    </div>
    <div class="menu-item" @click="goPointsgoods">
      <i class="iconfont"><img class="menu-item-icon" src="../../../assets/image/home/icon_top_cumulative_pre.png" /></i>
      <span class="menu-item-title">积分商城</span>
    </div>
    <div class="menu-item" @click="myOrder">
      <i class="iconfont"><img class="menu-item-icon" src="../../../assets/image/home/icon_top_order_pre.png" /></i>
      <span class="menu-item-title">我的订单</span>
    </div>
<!--    <div class="menu-item" @click="goArticleclass">
      <i class="iconfont bg-4">&#xe674;</i>
      <span class="menu-item-title">帮助中心</span>
    </div>
    <div class="menu-item" @click="goMemberIndex">
      <i class="iconfont bg-2">&#xe68c;</i>
      <span class="menu-item-title">个人中心</span>
    </div>-->
    <div class="menu-item" @click="goGroupBuy">
      <i class="iconfont"><img class="menu-item-icon" src="../../../assets/image/home/icon_top_knock_pre.png" /></i>
      <span class="menu-item-title">抢购</span>
    </div>
    <div class="menu-item" @click="goPresell">
      <i class="iconfont"><img class="menu-item-icon" src="../../../assets/image/home/icon_top_yushou_pre.png" /></i>
      <span class="menu-item-title">预售</span>
    </div>
    <div class="menu-item"  v-for="(item, index) in navs" :key="index" @click="goAdUrl(item)">
      <i class="iconfont"><img class="menu-item-icon" :src="item.adv_code" /></i>
      <span class="menu-item-title">{{item.adv_title}}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'HomeMenu',
  props: ['items'],
  computed: {
    ...mapState({
      isOnline: state => state.member.isOnline,
      navs: state => state.home.navs
    })
  },
  methods: {
    showLogin () {
      this.$router.push({ name: 'HomeMemberLogin' })
    },
    goPointsgoods () {
      this.$router.push({ 'name': 'HomePointsgoods' })
    },
    goStoreclass () {
      this.$router.push({ 'name': 'HomeStoreclass' })
    },
    goPintuan () {
      this.$router.push({ 'name': 'HomePintuanList' })
    },
    goBargain () {
      this.$router.push({ 'name': 'HomeBargainlist' })
    },
    goBrand () {
      this.$router.push({ 'name': 'HomeBrand' })
    },
    goArticleclass () {
      this.$router.push({ 'name': 'HomeArticleclass' })
    },
    goMemberIndex () {
      this.$router.push({ 'name': 'MemberIndex' })
    },
    goGroupBuy () {
      this.$router.push({ 'name': 'HomeGroupBuyList' })
    },
    goPresell () {
      this.$router.push({ 'name': 'HomePresellList' })
    },
    goMemberPointSignin () {
      this.$router.push({ 'name': 'MemberPointSignin' })
    },
    myOrder () {
      if (this.isOnline) {
        this.$router.push({
          name: 'MemberOrderList'
        })
      } else {
        this.showLogin()
      }
    },
    goAdUrl (item) {
      this.$router.push({path:item.adv_typedate})
    }
  }
}
</script>

<style lang="scss" scoped>

  .menu {
    overflow: hidden;
    justify-content: space-around;
    background: #FFFFFF;
    box-sizing: border-box;
    padding-left:.7rem;
    padding-right:.7rem;
    margin-bottom:$modelSpace;
    .menu-item {
      width:20%;
      padding:0 .7rem;
      padding-bottom:20%;
      height: 0;
      box-sizing: border-box;
      text-align:center;
      position: relative;
      float: left;
      .iconfont{
        position: absolute;
        margin:auto;
        top: 0;
        bottom:1.4rem;
        left:.7rem;
        right:.7rem;
        font-size:0;
        color:#fff;
        overflow: hidden;
        display:block;
        text-align: center;
      }
      .menu-item-icon {
        width: 100%;
        height: 100%;
        overflow: hidden;
      }
      .menu-item-title {
        position: absolute;
        left:0;
        right:0;
        bottom:.6rem;
        display:block;
        color: $formInputColor;
        font-size:$fontSize;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .bg-1{background-image: linear-gradient(to bottom , #d69dcc,#e8198b );}
  .bg-2{background-image: linear-gradient(to bottom , #04befe,#4481eb );}
  .bg-3{background-image: linear-gradient(to bottom , #cc208e,#6713d2 );}
  .bg-4{background-image: linear-gradient(to bottom , #ff9a44,#fc6076 );}
  .bg-5{background-image: linear-gradient(to bottom , #00ecbc,#007adf );}
  .bg-6{background-image: linear-gradient(to bottom , #ff8177,#b12a5b );}
</style>
